import { parseJSON, parseISO, isValid, format, toDate } from "date-fns";

import { NO_CONTENT_VALUE } from "./constants";

export type DateType = number | Date;
export type RawDateType = string | DateType;

export enum DateFormat {
  ClientDefaultFormat = "dd.MM.yyyy HH:mm",
  DateTime = "dd.MM.yyyy HH:mm:ss",
  UTC = "yyyy-MM-dd'T'HH:mm:ss.sssxxx",
  AxisTooltip = "d MMMM yyyy",
  ShortDate = "yyyy-MM-dd",
}

interface FormatDateOptions {
  dateFormat?: DateFormat | string;
  defaultValue?: RawDateType;
}

const stringDateParsers: ((date: string) => DateType)[] = [parseJSON, parseISO, rawDate => new Date(rawDate)];

export const getDate = (rawDate?: RawDateType | null): Date => {
  if (!rawDate) return null;

  if (typeof rawDate === "string") {
    for (const parser of stringDateParsers) {
      const date = parser(rawDate);

      if (isValid(date)) {
        return toDate(date);
      }
    }

    return null;
  }

  const parsedDate = toDate(rawDate);

  return isValid(parsedDate) ? parsedDate : null;
};

export const formatDate = (
  date?: RawDateType,
  { dateFormat = DateFormat.ClientDefaultFormat, defaultValue = NO_CONTENT_VALUE }: FormatDateOptions = {},
): string => {
  const dateValue = date ? getDate(date) : null;

  if (isValid(dateValue)) {
    return format(dateValue, dateFormat);
  }

  return `${defaultValue}`;
};
